import React, { useState, useContext, useEffect,useCallback } from 'react';
import { Link,useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button, FormControlLabel, Checkbox, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ShopContext } from '../../Context/ShopContext';
import { ParcelShopSelector } from '@frontboi/mondial-relay/browser';

import ship from '../Assets/ship';
import './Checkoutbox.css';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const Checkoutbox = () => {
  const [expanded, setExpanded] = useState('shipping');
  const [billingSameAsShipping, setBillingSameAsShipping] = useState(true);
  const [phone, setPhone] = useState(''); // State pour le téléphone
  const [paymentMethod, setPaymentMethod] = useState('stripe');
  const [acceptedCGV, setAcceptedCGV] = useState(false); // State pour l'acceptation des CGV
  const { cartItems, tempOrder, updateTempOrder, userDetails } = useContext(ShopContext);
  const navigate = useNavigate();
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const currentLang = pathParts[1] || 'en';
  const { t } = useTranslation();
  
    // État local pour stocker les informations des produits récupérées du backend
    const [productData, setProductData] = useState({});

        // Fonction pour récupérer les détails des produits du backend
        const fetchProductDetails = useCallback(async (idstore) => {
          try {
              const response = await fetch(`${backendUrl}/product/${idstore}`);
              const data = await response.json();
              if (data.success) {
                  setProductData(prevState => ({
                      ...prevState,
                      [idstore]: data.product
                  }));
              } else {
                  console.error(`Product with idstore ${idstore} not found`);
              }
          } catch (error) {
              console.error(`Error fetching product with idstore ${idstore}:`, error);
          }
      }, []); 

      useEffect(() => {
        Object.keys(cartItems).forEach(idstore => {
          if (cartItems[idstore] > 0) {
            fetchProductDetails(idstore);
          }
        });
      }, [cartItems, fetchProductDetails]); // Assurez-vous d'inclure fetchProductDetails
      
    // Calculer le total de tous les produits dans le panier
    const totalCartAmount = Object.keys(cartItems).reduce((total, idstore) => {
      const product = productData[idstore];
      const quantity = cartItems[idstore];
      if (product && quantity > 0) {
          return total + (product.pricettc * quantity);
      }
      return total;
  }, 0);

  useEffect(() => {
    updateTempOrder({ cartItems });
  }, [cartItems, updateTempOrder]);

  useEffect(() => {
    if (userDetails?.phone) {
      setPhone(userDetails.phone);
    }
  }, [userDetails]);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  const calculateShippingCost = (address,totalCartAmount) => {
    //console.log(address);
    //console.log(address.transport);
    if (address.country === 'France') {
      // Si le montant total du panier est supérieur à 50€
      if (totalCartAmount > 50) {
        if (address.transport === 'MondialRelay') {
          return 0; // Gratuit pour Mondial Relay
        } else if (address.transport === 'Colissimo') {
          return 4.90; // +4 euros pour Colissimo
        } else if (address.transport === 'Colissimosignature') {
          return 6.90; // +6 euros pour Colissimo avec signature
        }
      } else {
        // Si le montant total du panier est inférieur ou égal à 50€
        if (address.transport === 'MondialRelay') {
          return 4.90; // +4.90 euros pour Mondial Relay
        } else if (address.transport === 'Colissimo') {
          return 7.90; // +8.90 euros pour Colissimo
        } else if (address.transport === 'Colissimosignature') {
          return 10.90; // +11.90 euros pour Colissimo avec signature
        }
      }
    }


    
  
    if (address.country === 'Netherlands' || address.country === 'Germany' || address.country === 'Italy'|| address.country === 'Spain'|| address.country === 'Belgium') {
      // Si le montant total du panier est supérieur à 50€
      if (totalCartAmount > 50) {
        if (address.transport === 'MondialRelay') {
          return 0; // Gratuit pour Mondial Relay
        } else if (address.transport === 'Colissimo') {
          return 10.90; // +4 euros pour Colissimo
        }
      } else {
        // Si le montant total du panier est inférieur ou égal à 50€
        if (address.transport === 'MondialRelay') {
          return 6.90; // +4.90 euros pour Mondial Relay
        } else if (address.transport === 'Colissimo') {
          return 14.90; // +8.90 euros pour Colissimo
        }
      }

    }


    // Pour les autres pays ou modes de livraison
    return 15; // +10 euros par défaut pour le reste des pays
  };
  


  const handleShippingSubmit = (address) => {
    //const shippingCost = address.country === 'France' ? 0 : 10;
    const shippingCost = calculateShippingCost(address,totalCartAmount);
    const orderTotal = totalCartAmount + shippingCost;
    updateTempOrder({
      shippingAddress: address,
      shippingCost,
      orderTotal,
    });
    setExpanded('billing');
  };

  const handleBillingSubmit = (address) => {
    updateTempOrder({ billingAddress: address });
    setExpanded('phone');
  };

  const handlePhoneSubmit = () => {
    // Vérifier si le numéro de téléphone est bien défini
    if (phone) {
        updateTempOrder({ phone });
        // Attendre que l'état soit bien mis à jour avant de passer au panneau suivant
        setTimeout(() => {
            setExpanded('payment');
        }, 100); // Petit délai pour assurer que l'état est bien mis à jour avant de changer le panneau
    } else {
        // Si le téléphone est vide, afficher un message d'erreur
        alert(t('phone_required'));
    }
};
const handlePaymentSubmit = () => {
  //console.log(tempOrder);
  if (acceptedCGV) {
  //  setPaymentMethod(paymentMethod); // Cette ligne est un exemple, vous devez définir ce que vous voulez ici
  //console.log(paymentMethod);
  if (paymentMethod==="stripe"){
    navigate(`/${currentLang}/checkoutpayment`);
  }else{
    navigate(`/${currentLang}/checkoutpaymentPP`);
  }
  } else {
    alert(t('needcgv'));
  }
};


useEffect(() => {
  if (paymentMethod) {
    // Le paiement a été mis à jour, maintenant mettez à jour l'ordre temporaire
    updateTempOrder({ paymentMethod });
    /*console.log('Temporary Order:', tempOrder);*/
    /*navigate(`/${currentLang}/checkoutpayment`);*/
  }
}, [paymentMethod,updateTempOrder]); // Cet effet se déclenche chaque fois que `paymentMethod` change


  return (
    <div className='checkoutbox'>
      <Accordion expanded={expanded === 'shipping'} onChange={handleAccordionChange('shipping')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography><span className='checkout-title'>{t('address.shipping')}</span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ShippingAddressForm onSubmit={handleShippingSubmit} />
        </AccordionDetails>
      </Accordion>
      
      <Accordion expanded={expanded === 'billing'} onChange={handleAccordionChange('billing')} disabled={!tempOrder.shippingAddress}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography><span className='checkout-title'>{t('address.billing')}</span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <BillingAddressForm 
            onSubmit={handleBillingSubmit} 
            sameAsShipping={billingSameAsShipping} 
            setSameAsShipping={setBillingSameAsShipping} 
            shippingAddress={tempOrder.shippingAddress}  
          />
        </AccordionDetails>
      </Accordion>
      
      <Accordion expanded={expanded === 'phone'} onChange={handleAccordionChange('phone')} disabled={!tempOrder.billingAddress}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography><span className='checkout-title'>{t('address.phonenumber')}</span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <PhoneNumberForm phone={phone} setPhone={setPhone} onSubmit={handlePhoneSubmit} />
        </AccordionDetails>
      </Accordion>
      
      <Accordion expanded={expanded === 'payment'} onChange={handleAccordionChange('payment')} disabled={!tempOrder.phone}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography><span className='checkout-title'>{t('validateorder')}</span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <PaymentMethodForm 
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
            onSubmit={handlePaymentSubmit} 
            acceptedCGV={acceptedCGV} 
            setAcceptedCGV={setAcceptedCGV} 
          />
          <OrderSummary handlePaymentSubmit={handlePaymentSubmit} />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

const OrderSummary = ({ handlePaymentSubmit }) => {
  const {  cartItems, tempOrder } = useContext(ShopContext);
  
  const shippingCost = tempOrder.shippingCost || 0;
  //const totalCartAmount = tempOrder.orderTotal-tempOrder.shippingCost ;
  //const orderTotal = tempOrder.orderTotal;
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;
  const frontendUrl = process.env.REACT_APP_FRONTEND_URL;

    // État local pour stocker les informations des produits récupérées du backend
    const [productData, setProductData] = useState({});

        // Fonction pour récupérer les détails des produits du backend
        const fetchProductDetails = useCallback(async (idstore) => {
          try {
              const response = await fetch(`${backendUrl}/product/${idstore}`);
              const data = await response.json();
              if (data.success) {
                  setProductData(prevState => ({
                      ...prevState,
                      [idstore]: data.product
                  }));
              } else {
                  console.error(`Product with idstore ${idstore} not found`);
              }
          } catch (error) {
              console.error(`Error fetching product with idstore ${idstore}:`, error);
          }
      }, []); 

      useEffect(() => {
        Object.keys(cartItems).forEach(idstore => {
          if (cartItems[idstore] > 0) {
            fetchProductDetails(idstore);
          }
        });
      }, [cartItems, fetchProductDetails]); // Maintenant, c'est sûr d'ajouter fetchProductDetails

  return (
    <div className="order-summary checkoutbox-input checkout-title">
      <div className='order-summary-items'>
        
      {Object.keys(cartItems).map(idstore => {
        const quantity = cartItems[idstore];
        const product = productData[idstore];
        //console.log(product);
        if (quantity > 0 && product) {
                    return (
                  <div key={idstore}>
                <div className="cartitems-format cartitems-format-main">
                  <img src={`${frontendUrl}/${product.image1}`} alt="" className='carticon-product-icon' />
                  <p><p>{currentLanguage === 'en' ? product.name_en : product.name}</p></p>
                  <p>{product.pricettc.toFixed(2)} €</p>
                  <p>x {cartItems[idstore]}</p>
                  <p>{(product.pricettc * cartItems[idstore]).toFixed(2)} €</p>
                </div>
                <hr />
                      </div>
                  );
                }
return null;
})}
      </div>
      <div className="order-summary-total">
        <Typography className="order-summary-total">{t('cgv.section4.shippingCosts.title')} {shippingCost.toFixed(2)} €</Typography>
        <Typography className="order-summary-total">Total (Inc. tax): {tempOrder.orderTotal.toFixed(2)} €</Typography>
      </div>
        <Button onClick={handlePaymentSubmit} variant="contained">
        {t('completepay')}
        </Button>
    </div>
  );
};

const ShippingAddressForm = ({ onSubmit }) => {
  const { cartItems, userDetails } = useContext(ShopContext);
  const [productData, setProductData] = useState({});
  const [selectedRelayPoint, setSelectedRelayPoint] = useState(null);
  const [showMapSelector, setShowMapSelector] = useState(false);
  const [deliveryMethod, setDeliveryMethod] = useState('MondialRelay'); 
  const [address, setAddress] = useState({
    firstname: userDetails?.firstname || '',
    lastname: userDetails?.lastname || '',
    street1: '',
    street2: '',
    postalcode: '',
    city: '',
    country: 'France',
    transport: 'MondialRelay',
    relai_info: '',
  });
  const [errors, setErrors] = useState({});
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  
//console.log(tempOrder);

  useEffect(() => {
    const fetchShippingAddress = async () => {
      try {
        const response = await fetch(`${backendUrl}/getaddresses`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'auth-token': `${localStorage.getItem('auth-token')}`,
            'Content-type': 'application/json',
          },
          body: JSON.stringify({ addressType: 0 }),
        });
        const data = await response.json();
        if (data && data.length > 0) {
          const shippingAddress = data[0];
          setAddress({
            firstname: userDetails?.firstname || '',
            lastname: userDetails?.lastname || '',
            street1: shippingAddress.street1 || '',
            street2: shippingAddress.street2 || '',
            postalcode: shippingAddress.postalcode || '',
            city: shippingAddress.city || '',
            country: shippingAddress.country || '',
            transport: 'MondialRelay',
            relai_info:'',
          });
        }
      } catch (error) {
        console.error('Failed to fetch shipping address', error);
      }
    };

    fetchShippingAddress();
  }, [userDetails,backendUrl]);

  const validate = () => {
    let tempErrors = {};
    if (!address.firstname) tempErrors.firstname = t('address.firstrequire');
    if (!address.lastname) tempErrors.lastname = t('address.lastrequire');
    if (!address.street1) tempErrors.street1 = t('address.streetrequire')
    if (!address.postalcode) tempErrors.postalcode = t('address.postalrequire');
    if (!address.city) tempErrors.city = t('address.cityrequire');
    if (!address.country) tempErrors.country = t('address.countryrequire');


    // Vérification du point relais si Mondial Relay est choisi et si le pays est France ou Belgium
    if (
      deliveryMethod === 'MondialRelay' &&
      (address.country === 'France' || address.country === 'Belgium' || address.country === 'Germany'|| address.country === 'Netherlands'|| address.country === 'Italy'|| address.country === 'Spain') &&
      !selectedRelayPoint
    ) {
      tempErrors.selectedRelayPoint = t('shipping_details.relaypointselect');
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  const { t } = useTranslation();
  const handleChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    //console.log(address);
    if (validate()) {
      onSubmit(address);
    }
  };

  const handleDeliveryMethodChange = (e) => {
    setDeliveryMethod(e.target.value);
    setAddress((prevAddress) => ({
      ...prevAddress,
      transport: e.target.value || '', // ID du point relais
    }));
  };

  const handleRelayPointSelect = (selectedPoint) => {
    //console.log(selectedPoint);
    setSelectedRelayPoint(selectedPoint);
  
    // Met à jour l'adresse avec les informations du point relais sélectionné
    if (selectedPoint) {
      setAddress((prevAddress) => ({
        ...prevAddress,
        relai_info: selectedPoint || '', // ID du point relais
      }));
    }
  };


        // Fonction pour récupérer les détails des produits du backend
        const fetchProductDetails = useCallback(async (idstore) => {
          try {
              const response = await fetch(`${backendUrl}/product/${idstore}`);
              const data = await response.json();
              if (data.success) {
                  setProductData(prevState => ({
                      ...prevState,
                      [idstore]: data.product
                  }));
              } else {
                  console.error(`Product with idstore ${idstore} not found`);
              }
          } catch (error) {
              console.error(`Error fetching product with idstore ${idstore}:`, error);
          }
      }, []); 

      useEffect(() => {
        Object.keys(cartItems).forEach(idstore => {
          if (cartItems[idstore] > 0) {
            fetchProductDetails(idstore);
          }
        });
      }, [cartItems, fetchProductDetails]); // Assurez-vous d'inclure fetchProductDetails


    //console.log(cartItems);
    // Calculer le total de tous les produits dans le panier
    const totalCartAmount = Object.keys(cartItems).reduce((total, idstore) => {
      const product = productData[idstore];
      const quantity = cartItems[idstore];
      if (product && quantity > 0) {
          return total + (product.pricettc * quantity);
      }
      return total;
  }, 0);
  //console.log(address.country);
  //console.log(totalCartAmount);
  return (
    <div className='checkoutbox-input'>

<TextField
        label={t('firstname')}
        name="firstname"
        value={address.firstname}
        onChange={handleChange}
        error={!!errors.firstname}
        helperText={errors.firstname}
        fullWidth
      />
      <TextField
        label={t('lastname')}
        name="lastname"
        value={address.lastname}
        onChange={handleChange}
        error={!!errors.lastname}
        helperText={errors.lastname}
        fullWidth
      />
      <TextField
        label={t('address.street1')}
        name="street1"
        value={address.street1}
        onChange={handleChange}
        error={!!errors.street1}
        helperText={errors.street1}
        fullWidth
      />
      <TextField
        label={t('address.street2')}
        name="street2"
        value={address.street2}
        onChange={handleChange}
        fullWidth
      />
      <TextField
        label={t('address.postalcode')}
        name="postalcode"
        value={address.postalcode}
        onChange={handleChange}
        error={!!errors.postalcode}
        helperText={errors.postalcode}
        fullWidth
      />
      <TextField
        label={t('address.city')}
        name="city"
        value={address.city}
        onChange={handleChange}
        error={!!errors.city}
        helperText={errors.city}
        fullWidth
      />
      <FormControl fullWidth>
        <InputLabel>{t('address.country')}</InputLabel>
        <Select
          label={t('address.country')}
          name="country"
          value={address.country || 'France'}
          onChange={handleChange}
          error={!!errors.country}
        >
          {ship.map((country) => (
            <MenuItem key={country.id} value={country.name}>
              {country.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{errors.country}</FormHelperText>
      </FormControl>
      {/* Sélecteur de mode de livraison uniquement si le pays est "France" */}
      {(address.country === 'France') && (
        <FormControl fullWidth>
          <InputLabel>{t('Delivery')}</InputLabel>
          <Select
          label={t('Delivery')}
          value={address.transport}
          onChange={handleDeliveryMethodChange}
          >
            <MenuItem value="MondialRelay">{totalCartAmount < 50 ? '4.90€' : '0.00€'} - Mondial Relay</MenuItem>
            <MenuItem value="Colissimo">{totalCartAmount < 50 ? '7.90€' : '4.90€'} - {t('shipping_details.collissimo')}</MenuItem>
            <MenuItem value="Colissimosignature">{totalCartAmount < 50 ? '10.90€' : '6.90€'} - {t('shipping_details.collissimosign')}</MenuItem>
          </Select>
        </FormControl>

      )}

{(address.country === 'Belgium'|| address.country === 'Germany'|| address.country === 'Netherlands'|| address.country === 'Italy'|| address.country === 'Spain') && (
        <FormControl fullWidth>
          <InputLabel>{t('Delivery')}</InputLabel>
          <Select
          label={t('Delivery')}
          value={address.transport}
          onChange={handleDeliveryMethodChange}
          >
            <MenuItem value="MondialRelay">{totalCartAmount < 50 ? '6.90€' : '0.00€'} - Mondial Relay</MenuItem>
            <MenuItem value="Colissimo">{totalCartAmount < 50 ? '14.90€' : '10.90€'} - {t('shipping_details.collissimo')}</MenuItem>
          </Select>
        </FormControl>

      )}


      

        {/* Bouton pour afficher le sélecteur de point relais, uniquement si Mondial Relay est sélectionné */}
      {(address.country === 'France' || address.country === 'Belgium'|| address.country === 'Germany'|| address.country === 'Netherlands'|| address.country === 'Italy'|| address.country === 'Spain') && deliveryMethod === 'MondialRelay' && (
        <>
          <Button onClick={() => setShowMapSelector(true)}>{t('shipping_details.relayselect')}</Button>
          {showMapSelector && (
             <div style={{ width: '100%', height: '100%' }}>
            <ParcelShopSelector
              weight={900} // (in grams) optional, filters parcel shops by package weight
              nbResults={7} // optional (default: 7)
              deliveryMode="24R" // optional (default: "24R")
              brandIdAPI="CC23D7KU" // optional (default: "BDTEST", replace with your Brand Id API value for production usage)
              defaultCountry={
                address.country === 'Belgium' ? 'BE' :
                address.country === 'Germany' ? 'DE' :
                address.country === 'Italy' ? 'IT' :
                address.country === 'Netherlands' ? 'NL' :
                address.country === 'Spain' ? 'ES' : 
                'FR' // Default to FR if no specific country matches
              }  // optional (default: "FR")
              showResultsOnMap="False"
              defaultPostcode={address.postalcode} // optional (default: "59000")
              allowedCountries="FR,BE,DE,IT,ES,NL" // optional (default: "FR")
              onParcelShopSelected={handleRelayPointSelect} // setter function when a parcel shop is clicked
            />
            </div>
          )}

          {/* Détails du point relais sélectionné */}
          <div style={{ marginBottom: '12px', padding: '0px', border: '0px solid #ccc', borderRadius: '8px' }}>
            {selectedRelayPoint ? (
              <div>
                <p><b>{t('shipping_details.selectedrelay')}</b></p>
                <p>{selectedRelayPoint.Nom}</p>
                <p>{selectedRelayPoint.Adresse1}</p>
                <p>{selectedRelayPoint.Ville}</p>
                
              </div>
            ) : (
              <p>{t('shipping_details.norelay')}</p>
            )}
          </div>

    {/* Affichage du message d'erreur pour le point relais */}
    {errors.selectedRelayPoint && (
      <p style={{ color: 'red', fontSize: '0.9em', marginTop: '4px' }}>
        {errors.selectedRelayPoint}
      </p>
    )}
        </>
      )}

      <Button onClick={handleSubmit}>{t('address.usethisaddress')}</Button>
    </div>
  );
};

const BillingAddressForm = ({ onSubmit, sameAsShipping, setSameAsShipping, shippingAddress }) => {
  const [address, setAddress] = useState({
    firstname: '',
    lastname: '',
    street1: '',
    street2: '',
    postalcode: '',
    city: '',
    country: ''
  });
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  useEffect(() => {
    if (sameAsShipping) {
      setAddress(shippingAddress);
    } else {
      setAddress({
        firstname: '',
        lastname: '',
        street1: '',
        street2: '',
        postalcode: '',
        city: '',
        country: ''
      });
    }
  }, [sameAsShipping, shippingAddress]);

  const validate = () => {
    if (sameAsShipping) return true;
    let tempErrors = {};
    if (!address.firstname) tempErrors.firstname = t('address.firstrequire');
    if (!address.lastname) tempErrors.lastname = t('address.lastrequire');
    if (!address.street1) tempErrors.street1 = t('address.streetrequire')
    if (!address.postalcode) tempErrors.postalcode = t('address.postalrequire');
    if (!address.city) tempErrors.city = t('address.cityrequire');
    if (!address.country) tempErrors.country = t('address.countryrequire');
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (validate()) {
      onSubmit(address);
    }
  };

  return (
    <div className='checkoutbox-input'>
      <FormControlLabel 
        control={
          <Checkbox
            checked={sameAsShipping}
            onChange={(e) => setSameAsShipping(e.target.checked)}
            sx={{
              color: '#0b2946', // Couleur de la checkbox par défaut
              '&.Mui-checked': {
                color: '#0b2946', // Couleur quand la checkbox est cochée
              },
            }}
          />
        }
        label={t('address.same')}
      />
      {!sameAsShipping && (
        <div className='checkoutbox-input'>
          <TextField
            label={t('firstname')}
            name="firstname"
            value={address.firstname}
            onChange={handleChange}
            error={!!errors.firstname}
            helperText={errors.firstname}
          />
          <TextField
            label={t('lastname')}
            name="lastname"
            value={address.lastname}
            onChange={handleChange}
            error={!!errors.lastname}
            helperText={errors.lastname}
          />
          <TextField
            label={t('address.street1')}
            name="street1"
            value={address.street1}
            onChange={handleChange}
            error={!!errors.street1}
            helperText={errors.street1}
          />
          <TextField
            label={t('address.street2')}
            name="street2"
            value={address.street2}
            onChange={handleChange}
          />
          <TextField
            label={t('address.postalcode')}
            name="postalcode"
            value={address.postalcode}
            onChange={handleChange}
            error={!!errors.postalcode}
            helperText={errors.postalcode}
          />
          <TextField
            label={t('address.city')}
            name="city"
            value={address.city}
            onChange={handleChange}
            error={!!errors.city}
            helperText={errors.city}
          />
          <FormControl fullWidth>
            <InputLabel>{t('address.country')}</InputLabel>
            <Select
              name="country"
              value={address.country || ''}
              onChange={handleChange}
              label={t('address.country')}
              error={!!errors.country}
            >
              {ship.map((country) => (
                <MenuItem key={country.id} value={country.name}>
                  {country.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors.country}</FormHelperText>
          </FormControl>
        </div>
      )}
      <Button onClick={handleSubmit}>{t('address.usethisaddress')}</Button>
    </div>
  );
};


const PhoneNumberForm = ({ phone, setPhone, onSubmit }) => {
  const [error, setError] = useState(''); // State pour gérer l'erreur
  const { t } = useTranslation();

  const handleChange = (e) => {
    setPhone(e.target.value); // Directement mettre à jour l'état phone
    if (error) {
      setError(''); // Efface l'erreur dès que l'utilisateur modifie le champ
    }
  };

  const handleSubmit = () => {
    if (!phone) {
      setError(t('phone_required')); // Message d'erreur si le champ est vide
      return;
    }
    onSubmit(); // Appelle bien la fonction onSubmit
  };

  return (
    <div className='checkoutbox-input'>
      <TextField
        label={t('address.phonenumber')} // Ajoute une étiquette explicite pour le champ
        value={phone} // Utilise phone directement
        onChange={handleChange}
        fullWidth
        error={!!error} // Déclenche l'état d'erreur dans le champ
        helperText={error} // Affiche le message d'erreur
      />
      <Button onClick={handleSubmit}>{t('usephone')}</Button>
    </div>
  );
};




const PaymentMethodForm = ({  paymentMethod, setPaymentMethod,onSubmit, acceptedCGV, setAcceptedCGV }) => {
  
  const [errors] = useState({});
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const currentLang = pathParts[1] || 'en';
  const { t } = useTranslation();

  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleCGVChange = (e) => {
    setAcceptedCGV(e.target.checked);
  };

  /*
useEffect(() => {
  console.log("Payment method updated:", paymentMethod);
}, [paymentMethod]);
*/

  return (
    <div className='checkoutbox-input'>
      <FormControl>
        <InputLabel>{t('paymentmethod')}</InputLabel>
        <Select
          value={paymentMethod}
          onChange={handlePaymentMethodChange}
          label={t('paymentmethod')}
          error={!!errors.paymentMethod}
        >
          <MenuItem value="stripe">{t('creditcard')}</MenuItem>
          <MenuItem value="paypal">Paypal</MenuItem>
        </Select>
        <FormHelperText>{errors.paymentMethod}</FormHelperText>
      </FormControl>
      <div>
      <FormControlLabel 
        control={
          <Checkbox
            checked={acceptedCGV}
            onChange={handleCGVChange}
            sx={{
              color: '#0b2946', // Couleur de la checkbox par défaut
              '&.Mui-checked': {
                color: '#0b2946', // Couleur quand la checkbox est cochée
              },
            }}
          />
        }
        label={t('acceptcgv')}
      />
      <Link to={`/${currentLang}/cgv`} target="_blank" rel="noopener noreferrer">{t('readcgv')}</Link></div>
    </div>
  );
};

export default Checkoutbox;
